import { render, staticRenderFns } from "./objectGroupSetAdd.vue?vue&type=template&id=95913c86"
import script from "./objectGroupSetAdd.vue?vue&type=script&lang=js"
export * from "./objectGroupSetAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95913c86')) {
      api.createRecord('95913c86', component.options)
    } else {
      api.reload('95913c86', component.options)
    }
    module.hot.accept("./objectGroupSetAdd.vue?vue&type=template&id=95913c86", function () {
      api.rerender('95913c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/objectGroupSetAdd.vue"
export default component.exports